import $global from '@xt/client/store/global'
import type { ClasshourItem } from '@xt/client/entities/course-v2/types.d'
import type { Asset, Material, BaseTemplate, TopDirClasshourLayout, BottomDirClasshourLayout } from '../types.d'

export class TemplateTen implements BaseTemplate {
  /**
   * 当前课程进度 0 - 3
   */
  private taskSchedule: number
  /**
   * 头部课程(开学见面)是否已经发布
   */
  private withStartCourse: boolean
  /**
   * 尾部课程(小灶课)是否已经发布
   */
  private withEndCourse: boolean
  /**
   * 展示学习回顾
   */
  private showReview: boolean
  /**
   * 展示开课前请准备 与 学习回顾位置互斥
   */
  public showPrepare: boolean
  /**
   * 当前真实的课程进度索引，与taskSchedule相比 taskSchedule不会返回小灶课尾部课程的索引
   * 模版10  realCurrent: 0 - 11
   */
  public realCurrent: number

  constructor(options: {
    taskSchedule: number
    showReview: boolean
    showPrepare: boolean
    withStartCourse: boolean
    withEndCourse: boolean
    realCurrent: number
  }) {
    this.taskSchedule = options.taskSchedule
    this.showReview = options.showReview
    this.showPrepare = options.showPrepare
    this.withStartCourse = options.withStartCourse
    this.withEndCourse = options.withEndCourse
    this.realCurrent = options.realCurrent
  }

  private static assets: Record<string, Asset> = {
    'bg-style-v1': {
      url: `${$global.static}/images/course/pc/template/tpl-10/tpl-10-bg-style-v1.png`,
      width: 1438,
      height: 665
    },
    'material-sprite': {
      url: `${$global.static}/images/course/pc/template/tpl-10/tpl-10-sprites-v1.png`,
      width: 399,
      height: 356
    },
    'material-review': {
      url: `${$global.static}/images/course/pc/bg-review-v1.png`,
      width: 248,
      height: 218
    }
  }

  getTemplateSize() {
    return { width: 1438, height: 860, marginTop: 118, marginBottom: 0, marginLeft: 50 }
  }

  getBottomMaterialConfigList(): Array<Array<Material>> {
    console.log(this.realCurrent)
    // 数字角标 【top, left】
    const numberIndex = [
      [369, 502],
      [356, 178],
      [212, 360],
      [171, 629],
      [201, 968],
      [324, 1148],
      [573, 1142],
      [593, 873],
      [648, 665],
      [585, 463],
      [549, 188],
      [432, 775]
    ]

    return [
      [
        {
          type: 'normal',
          ...TemplateTen.assets['bg-style-v1'],
          visible: true,
          name: 'bg',
          top: 111,
          left: 0
        }
      ],
      [
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.withStartCourse,
          name: 'bg-tpl_10_number_star',
          top: numberIndex[0][0],
          left: numberIndex[0][1],
          x: -71,
          y: -258,
          self: {
            width: 27,
            height: 26
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 1,
          name: 'bg-tpl_10_number_1',
          top: numberIndex[1][0],
          left: numberIndex[1][1],
          x: -354,
          y: -5,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 2,
          name: 'bg-tpl_10_number_2',
          top: numberIndex[2][0],
          left: numberIndex[2][1],
          x: -354,
          y: -61,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 3,
          name: 'bg-tpl_10_number_3',
          top: numberIndex[3][0],
          left: numberIndex[3][1],
          x: -354,
          y: -229,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 4,
          name: 'bg-tpl_10_number_4',
          top: numberIndex[4][0],
          left: numberIndex[4][1],
          x: -354,
          y: -173,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 5,
          name: 'bg-tpl_10_number_5',
          top: numberIndex[5][0],
          left: numberIndex[5][1],
          x: -55,
          y: -305,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 6,
          name: 'bg-tpl_10_number_6',
          top: numberIndex[6][0],
          left: numberIndex[6][1],
          x: -354,
          y: -117,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 7,
          name: 'bg-tpl_10_number_7',
          top: numberIndex[7][0],
          left: numberIndex[7][1],
          x: -5,
          y: -305,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 8,
          name: 'bg-tpl_10_number_8',
          top: numberIndex[8][0],
          left: numberIndex[8][1],
          x: -155,
          y: -305,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 9,
          name: 'bg-tpl_10_number_9',
          top: numberIndex[9][0],
          left: numberIndex[9][1],
          x: -105,
          y: -305,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent !== 10,
          name: 'bg-tpl_10_number_10',
          top: numberIndex[10][0],
          left: numberIndex[10][1],
          x: -205,
          y: -305,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.withEndCourse,
          name: 'bg-tpl_10_number_star_end',
          top: numberIndex[11][0],
          left: numberIndex[11][1],
          x: -71,
          y: -258,
          self: {
            width: 27,
            height: 26
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.realCurrent > 0 && this.realCurrent < 11,
          name: 'bg-tpl_10_number_current',
          top: numberIndex[this.realCurrent][0],
          left: numberIndex[this.realCurrent][1],
          x: -255,
          y: -305,
          self: {
            width: 40,
            height: 46
          }
        }
      ]
    ]
  }

  getTopMaterialConfigList(): Array<Array<Material>> {
    return [
      [
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 1 || this.taskSchedule === 0,
          name: 'bg-tpl_10_material_01',
          top: 336,
          left: 144,
          x: -5,
          y: -258,
          self: {
            width: 56,
            height: 37
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 2,
          name: 'bg-tpl_10_material_02',
          top: 207,
          left: 311,
          x: -268,
          y: -177,
          self: {
            width: 57,
            height: 41
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 3,
          name: 'bg-tpl_10_material_03',
          top: 138,
          left: 609,
          x: -107,
          y: -195,
          self: {
            width: 46,
            height: 51
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 4,
          name: 'bg-tpl_10_material_04',
          top: 185,
          left: 988,
          x: -268,
          y: -124,
          self: {
            width: 57,
            height: 43
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 5,
          name: 'bg-tpl_10_material_05',
          top: 305,
          left: 1182,
          x: -173,
          y: -5,
          self: {
            width: 85,
            height: 81
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 6,
          name: 'bg-tpl_10_material_06',
          top: 584,
          left: 1187,
          x: -5,
          y: -195,
          self: {
            width: 92,
            height: 53
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 7,
          name: 'bg-tpl_10_material_07',
          top: 630,
          left: 856,
          x: -268,
          y: -5,
          self: {
            width: 76,
            height: 59
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 8,
          name: 'bg-tpl_10_material_08',
          top: 673,
          left: 606,
          x: -163,
          y: -195,
          self: {
            width: 61,
            height: 37
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 9,
          name: 'bg-tpl_10_material_09',
          top: 632,
          left: 435,
          x: -268,
          y: -74,
          self: {
            width: 64,
            height: 40
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.taskSchedule === 10,
          name: 'bg-tpl_10_material_10',
          top: 551,
          left: 103,
          x: -173,
          y: -96,
          self: {
            width: 79,
            height: 57
          }
        }
      ],
      [
        {
          type: 'sprite',
          ...TemplateTen.assets['material-sprite'],
          visible: this.showPrepare,
          name: 'bg-tpl_10_prepare',
          top: -86,
          left: 1197,
          x: -89,
          y: -5,
          hover: {
            x: -5,
            y: -5
          },
          clickEventName: 'click-prepare',
          self: {
            width: 74,
            height: 180
          }
        },
        {
          type: 'sprite',
          ...TemplateTen.assets['material-review'],
          visible: this.showReview,
          name: 'bg-review',
          top: -104,
          left: 1153,
          x: -129,
          y: -5,
          hover: {
            x: -5,
            y: -5
          },
          clickEventName: 'click-review',
          self: {
            width: 114,
            height: 208
          }
        }
      ]
    ]
  }

  public getClasshourLayoutInfo(_item: ClasshourItem, index: number): TopDirClasshourLayout | BottomDirClasshourLayout {
    switch (index) {
      case 0:
        return { directionStyle: 'bottom', bottom: 501, left: 435 } satisfies BottomDirClasshourLayout
      case 1:
        return { directionStyle: 'bottom', bottom: 515, left: 117 } satisfies BottomDirClasshourLayout
      case 2:
        return { directionStyle: 'bottom', bottom: 660, left: 299 } satisfies BottomDirClasshourLayout
      case 3:
        return { directionStyle: 'bottom', bottom: 701, left: 568 } satisfies BottomDirClasshourLayout
      case 4:
        return { directionStyle: 'bottom', bottom: 671, left: 907 } satisfies BottomDirClasshourLayout
      case 5:
        return { directionStyle: 'bottom', bottom: 548, left: 1088 } satisfies BottomDirClasshourLayout
      case 6:
        return { directionStyle: 'top', top: 626, left: 1081 } satisfies TopDirClasshourLayout
      case 7:
        return { directionStyle: 'bottom', bottom: 279, left: 812 } satisfies BottomDirClasshourLayout
      case 8:
        return { directionStyle: 'top', top: 701, left: 604 } satisfies TopDirClasshourLayout
      case 9:
        return { directionStyle: 'bottom', bottom: 287, left: 403 } satisfies BottomDirClasshourLayout
      case 10:
        return { directionStyle: 'top', top: 604, left: 127 } satisfies TopDirClasshourLayout
      case 11:
        return { directionStyle: 'bottom', bottom: 438, left: 708 } satisfies BottomDirClasshourLayout
      default:
        throw new Error(`${index}`)
    }
  }
}
